<app-shell>
  <main>
    <router-outlet></router-outlet>
  </main>
</app-shell>
<!-- <app-footer></app-footer> -->
